// utils/auth.js
export const handleUnauthorized = () => {
  localStorage.removeItem("vedhvidhi-admin-token");
  localStorage.removeItem("vedhvidhi-admin-data");
  window.location.href = "/sign-in"; 
};
